import { NetworkPopUpType } from '../../network.pop-up.factory';
import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { translateFn } from '../../../../utils/translator.helper';
import { GzDialog } from '../../../../ui/gzDialog/component/GzDialog';
import { GzInstallPatchesWebComponent } from './component/GzInstallPatchesWebComponent';
import { TaskType } from '../../../../tasks/networkTasks/types';
import { CreateTaskRequest } from '../../types';
import { getFormattedDateForTask } from '../../../networkAppContainer/helpers/utils';
import { InstallPatchesScanTaskSpecifics } from './component/types';

export class InstallPatchesPopUp extends NetworkBasePopUp<GzInstallPatchesWebComponent> {
  private type = NetworkPopUpType.INSTALL_PATCHES;
  protected title = translateFn('Install patches');
  protected extraDialogConfigs: Partial<GzDialog> = {
    isWindow: true,
  };

  protected customSetup() {
    this.popUpContent = new GzInstallPatchesWebComponent();
    this.popUpContent.targets = this.transformProtectedEntitiesToTargetEntities();
  }

  protected async handleConfirmButtonClicked(event: CustomEvent) {
    const requestTargets = this.popUpContent.targets;
    const requestSpecifics: InstallPatchesScanTaskSpecifics = this.popUpContent.getRequestSpecifics();

    const formattedDate: string = getFormattedDateForTask();
    const taskName = translateFn('Patch Install {formattedDate}', { formattedDate: formattedDate });

    const request: CreateTaskRequest<InstallPatchesScanTaskSpecifics> = {
      settings: {
        specifics: requestSpecifics,
        targets: requestTargets,
        taskName: taskName,
        type: TaskType.TASK_TYPE_PATCH_INSTALL_PARENT,
      },
    };

    await this.createTask<InstallPatchesScanTaskSpecifics>(request);
  }
}
